/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.getSpinToWinPrizes

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.getSpinToWinPrizes.GetSpinToWinPrizesApi
import features.getSpinToWinPrizes.models.SpinToWinPrizesModel
import features.getSpinToWinPrizes.serializeGetSpinToWinPrizesState



/**
 * Get the spin to win prizes of a business [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("GetSpinToWinPrizesApi")
class GetSpinToWinPrizesApiJs {

    /**
     * Get the spin to win prizes of a business
     */
    fun getSpinToWinPrizes(
        overrideHeaders: String?, 
        businessId: String
    ): Promise<String?>  {
        return GlobalScope.promise {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

            val result = GetSpinToWinPrizesApi().getSpinToWinPrizes(
            overrideHeaders = decodedOverrideHeaders,
                        businessId = businessId
        ).toJsonResult<SpinToWinPrizesModel>()
        
            return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    

    fun observeGetSpinToWinPrizesState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        GetSpinToWinPrizesApi().getSpinToWinPrizesState.serializeGetSpinToWinPrizesState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
